import DataLoader from "@/components/DataLoader";
import { PRACTITIONER_PROFILE_QUERY } from "@/graphql/accounts";
import useDocTitle from "@/hooks/use-doc-title";

import ProfileForm from "./forms/ProfileForm";

export default function PractitionerProfile() {
  useDocTitle("Profile", false, "Regenerus");

  return (
    <>
      <DataLoader
        query={PRACTITIONER_PROFILE_QUERY}
        fetchPolicy="network-only"
        nextFetchPolicy="network-only"
        render={({ practitionerProfile }) =>
          practitionerProfile ? <ProfileForm practitionerProfile={practitionerProfile} /> : null
        }
      />
    </>
  );
}
